module.exports = new __parcel__URL__("WevrMasterAgreement.41ae5d4f.pdf").toString();